import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import KomodoToolbar from './KomodoToolbar';

import { MGSiteButton } from 'mgUiKit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'CloseButtonComponent';

class CloseButton extends React.Component {
    constructor(props) {
        super(props);
        
        this.handleCloseTab = this.handleCloseTab.bind(this);
    }

    componentDidMount() {
     
    }

   
    handleCloseTab(){
        this.context.handleTab(false);
    }

    render() {
      return (
        <>         
            <MGSiteButton
                title="Chiudi"               
                class="mg-userbox-btn-close-tab"
                label="Chiudi"
                disabled={false}
                primary={false}
                isButton={true}
                fullWidth={true}
                actionFunc={this.handleCloseTab}
            />

            <KomodoToolbar/>
        </>
        );
    }
}

CloseButton.displayName = componentName;

// PropTypes validation
CloseButton.propTypes = {};

// default props
CloseButton.defaultProps = {};

// contextTypes validation
CloseButton.contextTypes = {
    handleTab: PropTypes.func
}

export default  CloseButton;